import { withTheme } from '../config';
import { SocialIcon, } from '@rneui/base/dist/SocialIcon/SocialIcon';
export { SocialIcon };
export default withTheme(SocialIcon, 'SocialIcon');
